import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';

import { ColoredChip } from './ColoredChip';

interface IProps extends ICellRendererParams {
  placeholder?: string;
}

export const ChipCell = ({ value, placeholder = DEFAULT_PLACEHOLDER }: IProps) => {
  if (!value) {
    return <>{placeholder}</>;
  }

  return <ColoredChip value={value} />;
};
